import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export interface SkladMistoItem extends DropdownItem {
	Selected: boolean,
}

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		SklMistoIdList: [],
		Trideni: [],
		FilterBy: [],
	},
	edit: {
		InventuraId: null as number | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		SkladOzn: null as number | null,
		Text: null as string | null,
		PrevedeniDat: null as string | null,
		InvPredzpPrp: null as boolean | null,
		PrevedeniPracId: null as number | null,
		EditDat: null as string | null,
		EditPracId: null as number | null,
		InvSlepaPrp: null as boolean | null,
		AktualDat: null as string | null,
		MenaId1: null as number | null,
		SklMistoIdList: [] as number[],
		XPocet: null as number | null,
		Blokace: null as boolean | null,
		VstupPracIdText: null as string | null,
		PrevedeniPracIdText: null as string | null,
		MaxSkladMisto: null as number | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {
		SkladMistoOd: null as string | null,
		SkladMistoOdText: null as string | null,
		SkladMistoDo: null as string | null,
		SkladMistoDoText: null as string | null,
		FilterBy: 0 as number | null,
		Trideni: 0 as number | null,
		PrintZero: null as boolean | null,
		InvRadekOd: null as number | null,
		InvRadekDo: null as number | null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.SKLAD_MISTO_OD_SELECT_MAPPER](state, { data }) {
			state.localState.SkladMistoOd = data.value;
			state.localState.SkladMistoOdText = data.text;
		},
		[editMutations.SKLAD_MISTO_DO_SELECT_MAPPER](state, { data }) {
			state.localState.SkladMistoDo = data.value;
			state.localState.SkladMistoDoText = data.text;
		},
	},
	props: {
		mode: null,
	},
});
